const clampScore = (score) => Math.max(1, Math.min(10, score));

export const ELEMENT_CAREERS = {
  Moc: 'Giáo dục, Y tế, Nông nghiệp',
  Hoa: 'Nghệ thuật, Truyền thông, Điện tử',
  Tho: 'Bất động sản, Xây dựng, Logistics',
  Kim: 'Tài chính, Luật, Quân đội',
  Thuy: 'Ngoại giao, Du lịch, Thủy sản'
};

export const CAREER_GUIDANCE = {
  vi: {
    'Mộc': {
      summary: '👉 Hợp môi trường nuôi dưỡng sáng tạo và phát triển dài hạn.',
      fit: [
        'Giáo dục – đào tạo – huấn luyện',
        'Truyền thông – marketing – nội dung sáng tạo',
        'Thiết kế sản phẩm, UX/UI, xây trải nghiệm',
        'Nông nghiệp – môi trường – phát triển bền vững',
        'Nhân sự – kết nối cộng đồng'
      ],
      avoid: [
        'Công việc quá khô cứng, ít tương tác',
        'Vai trò chỉ số ngắn hạn, áp lực KPI cực cao',
        'Môi trường cạnh tranh nội bộ liên tục'
      ]
    },
    'Hỏa': {
      summary: '👉 Hợp vai trò cần tốc độ, truyền cảm hứng và dẫn dắt.',
      fit: [
        'Sales – kinh doanh – phát triển thị trường',
        'Sản phẩm/branding – marketing tăng trưởng',
        'Giải trí – sự kiện – truyền thông nhanh',
        'Khởi nghiệp – dự án cần bứt tốc',
        'Đào tạo kỹ năng mềm – thuyết trình'
      ],
      avoid: [
        'Công việc lặp lại, ít không gian thể hiện',
        'Vai trò hậu cần thuần túy, ít quyết định',
        'Môi trường thiếu mục tiêu rõ ràng'
      ]
    },
    'Thổ': {
      summary: '👉 Hợp lĩnh vực xây nền, ổn định và quản trị rủi ro.',
      fit: [
        'Bất động sản – xây dựng – quy hoạch',
        'Quản trị vận hành – quản lý dự án',
        'Tài chính kế toán – kiểm soát nội bộ',
        'Chuỗi cung ứng – logistics – kho vận',
        'Hành chính – pháp chế – compliance'
      ],
      avoid: [
        'Công việc biến động quá nhanh, thiếu quy trình',
        'Dự án cần đổi hướng liên tục',
        'Môi trường thiếu tính kỷ luật'
      ]
    },
    'Kim': {
      summary: '👉 Hợp vai trò cần kỷ luật, tối ưu và ra quyết định dứt khoát.',
      fit: [
        'Tài chính – kiểm toán – phân tích dữ liệu',
        'Kỹ thuật hệ thống – vận hành hạ tầng',
        'Luật – quy chuẩn – an ninh',
        'QA/QC – kiểm định – tiêu chuẩn hóa',
        'Quản trị rủi ro – đánh giá đầu tư'
      ],
      avoid: [
        'Công việc cảm tính, thiếu tiêu chí đo lường',
        'Môi trường thay đổi thất thường',
        'Vai trò cần giao tiếp xã giao quá nhiều'
      ]
    },
    'Thủy': {
      summary: '👉 Hợp lĩnh vực cần linh hoạt, phân tích sâu và dòng chảy thông tin.',
      fit: [
        'Nghiên cứu – phân tích – chiến lược',
        'CNTT – dữ liệu – bảo mật',
        'Tài chính thị trường – phân tích dòng tiền',
        'Tư vấn – coaching – hỗ trợ khách hàng',
        'Logistics – thương mại – vận tải'
      ],
      avoid: [
        'Công việc quá cứng nhắc, ít đổi mới',
        'Vai trò chỉ dựa vào quy trình cũ',
        'Môi trường thiếu học hỏi liên tục'
      ]
    }
  },
  en: {
    'Mộc': {
      summary: '👉 Best for long-term growth and creative cultivation.',
      fit: [
        'Education, training, coaching',
        'Media, marketing, content creation',
        'Product design, UX/UI, experience building',
        'Agriculture, environment, sustainability',
        'HR, community and people development'
      ],
      avoid: [
        'Rigid roles with little interaction',
        'Short-term KPI-only environments',
        'Constant internal competition'
      ]
    },
    'Hỏa': {
      summary: '👉 Best for fast-paced, inspiring, and leading roles.',
      fit: [
        'Sales, business development, growth',
        'Branding, marketing, product growth',
        'Events, entertainment, fast media',
        'Startups with rapid execution',
        'Soft-skills training, presentation'
      ],
      avoid: [
        'Repetitive work with little expression',
        'Pure back-office roles',
        'Goal-less environments'
      ]
    },
    'Thổ': {
      summary: '👉 Best for stability, foundation building, and risk control.',
      fit: [
        'Real estate, construction, planning',
        'Operations, project management',
        'Finance, accounting, internal control',
        'Supply chain, logistics',
        'Administration, legal, compliance'
      ],
      avoid: [
        'High volatility without process',
        'Constantly shifting priorities',
        'Low-discipline environments'
      ]
    },
    'Kim': {
      summary: '👉 Best for discipline, optimization, and decisive execution.',
      fit: [
        'Finance, audit, data analysis',
        'System engineering, infrastructure ops',
        'Law, standards, security',
        'QA/QC, quality compliance',
        'Risk management, investment analysis'
      ],
      avoid: [
        'Overly emotional roles',
        'Unpredictable environments',
        'Excessive social-heavy roles'
      ]
    },
    'Thủy': {
      summary: '👉 Best for flexibility, deep analysis, and information flow.',
      fit: [
        'Research, analytics, strategy',
        'IT, data, cybersecurity',
        'Market finance, cashflow analysis',
        'Consulting, coaching, customer success',
        'Logistics, trade, transportation'
      ],
      avoid: [
        'Overly rigid roles',
        'Stagnant processes',
        'Low learning environments'
      ]
    }
  }
};

const getDominantElement = (fiveElements) => (
  Object.entries(fiveElements || {}).sort(([, a], [, b]) => b - a)[0]?.[0]
);

export function careerRule({
  tenGodCounts,
  fiveElements,
  interactions,
  dungThan
} = {}) {
  const notes = [];
  const recommendations = [];
  const reasoning = [];
  let score = 7;

  const favorableElements = dungThan?.dung_than || [];
  if (favorableElements.includes('Kim')) {
    notes.push('Hợp ngành Kim: Tài chính, Luật, Cơ khí');
    reasoning.push({
      factor: 'Dụng Thần thiên về Kim',
      impact: 1,
      explanation: 'Kim đại diện cho tính kỷ luật, cấu trúc, phù hợp các lĩnh vực tài chính - pháp lý.'
    });
  }

  if (tenGodCounts?.ChinhQuan >= 2 && tenGodCounts?.ChinhAn >= 1) {
    score += 2;
    notes.push('Phù hợp công việc quản lý/công chức (Chính Quan + Chính Ấn)');
    recommendations.push('Rèn kỷ luật và kỹ năng lãnh đạo');
    reasoning.push({
      factor: 'Chính Quan ≥ 2 + Chính Ấn ≥ 1',
      impact: 2,
      explanation: 'Bộ Chính Quan - Chính Ấn giúp tăng uy tín và tính kỷ luật trong công việc.'
    });
  }

  if (tenGodCounts?.ThienQuan >= 1 && tenGodCounts?.ThuongQuan >= 1) {
    score += 1;
    notes.push('Hợp ngành sáng tạo, marketing, tự do (Thiên Quan + Thương Quan)');
    recommendations.push('Tập trung vào chuyên môn sáng tạo');
    reasoning.push({
      factor: 'Thiên Quan + Thương Quan',
      impact: 1,
      explanation: 'Tổ hợp này thiên về sáng tạo, dễ hợp môi trường năng động.'
    });
  }

  if (tenGodCounts?.ChinhTai >= 1 && tenGodCounts?.ThucThan >= 1) {
    score += 1;
    notes.push('Có duyên kinh doanh/buôn bán (Chính Tài + Thực Thần)');
    recommendations.push('Xây dựng kế hoạch kinh doanh rõ ràng');
    reasoning.push({
      factor: 'Chính Tài + Thực Thần',
      impact: 1,
      explanation: 'Thực Thần sinh tài, tăng khả năng tạo thu nhập ổn định.'
    });
  }

  if (tenGodCounts?.TyKien >= 3) {
    score -= 1;
    notes.push('Tỷ Kiên nhiều, cạnh tranh lớn, dễ khó hợp tác');
    recommendations.push('Học cách phối hợp nhóm');
    reasoning.push({
      factor: 'Tỷ Kiên ≥ 3',
      impact: -1,
      explanation: 'Tỷ Kiên mạnh khiến môi trường cạnh tranh cao, dễ va chạm quan điểm.'
    });
  }

  if (tenGodCounts?.ThuongQuan >= 2 && tenGodCounts?.ThienQuan >= 1) {
    score -= 1;
    notes.push('Thương Quan + Thiên Quan mất cân bằng, dễ đổi việc');
    recommendations.push('Ổn định mục tiêu nghề nghiệp');
    reasoning.push({
      factor: 'Thương Quan ≥ 2 + Thiên Quan ≥ 1',
      impact: -1,
      explanation: 'Năng lượng bộc phát cao dễ khiến quyết định nghề nghiệp thay đổi nhanh.'
    });
  }

  const dominantElement = getDominantElement(fiveElements);
  if (dominantElement && ELEMENT_CAREERS[dominantElement]) {
    notes.push(`Ngành ${dominantElement}: ${ELEMENT_CAREERS[dominantElement]}`);
    reasoning.push({
      factor: `Ngũ hành trội: ${dominantElement}`,
      impact: 1,
      explanation: 'Ngũ hành mạnh nhất thể hiện thiên hướng nghề nghiệp tự nhiên.'
    });
  }

  const clashCount = interactions?.filter((item) => item.type === 'xung').length || 0;
  if (clashCount >= 2) {
    score -= 2;
    notes.push('Có từ 2 cặp Xung trở lên → nghề dễ đa nhiệm, thay đổi liên tục');
    recommendations.push('Ưu tiên vai trò linh hoạt, học thêm kỹ năng mới');
    reasoning.push({
      factor: 'Xung ≥ 2',
      impact: -2,
      explanation: 'Từ 2 cặp Xung trở lên báo hiệu biến động nghề nghiệp hoặc môi trường thay đổi.'
    });
  }

  return {
    rating: clampScore(score),
    nhanXet: notes.length ? notes.join('; ') : 'Sự nghiệp ổn định, phát triển theo năng lực',
    khuyenNghi: recommendations,
    reasoning
  };
}
